import React from 'react';
import { createRoot } from 'react-dom/client';
import HelloWorld from '../components/HelloWorld';

import "./application.scss";

document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('root');

    if (rootElement) {
        const root = createRoot(rootElement);
        root.render(<HelloWorld />);
    }
})
